module.exports = __webpack_public_path__ + "media/images/icons/chart_up-9f58638c443a9c07309e83105a0b3e0d.svg";